module.exports = __webpack_public_path__ + "img/buyer.87e4e313.png";